import axios from '../utils/axios';

export const UploadObservationFile = (content) => {
    return axios.post('/prod/fhir/media', content).then((response) => {
        return response.data;
    });
};
